import { useDropdownState } from "../../../../../hooks";

import { DropDownMenu } from "../DropDownMenu/DropDownMenu";
import { HeaderNavButton } from "../HeaderNavButton/HeaderNavButton";

import { Arrow, ButtonWrapper, Wrapper } from "./NavItem.styled";

export const NavItem = ({ children, type, activeType, setActiveType }) => {
  const {
    isDropDownOpen,
    handleButton,
    isOpenMenu,
    isCloseMenu,
    handleCloseMenu,
    setIsHovering,
  } = useDropdownState(type, activeType, setActiveType);

  return (
    <Wrapper onMouseEnter={isOpenMenu} onMouseLeave={handleCloseMenu}>
      <ButtonWrapper>
        <HeaderNavButton handler={handleButton} isDropDownOpen={isDropDownOpen}>
          {children}
        </HeaderNavButton>

        {isDropDownOpen && <Arrow isTools={type === "tools"} />}
      </ButtonWrapper>

      <DropDownMenu
        isOpen={isDropDownOpen}
        closeMenu={isCloseMenu}
        type={type}
        setIsHovering={setIsHovering}
      />
    </Wrapper>
  );
};
